import { Circle } from 'components/Circle'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { StepRoot } from './Step.styles'

type StepProps = {
  number: string
  title: string
  description: string
}

export const Step = ({ number, title, description }: StepProps) => {
  return (
    <StepRoot>
      <Stack direction="column" gap="3" alignItems="center">
        <Circle variant="primary" border="thick" size={11}>
          <Text size="h2">{number}</Text>
        </Circle>

        <Stack direction="column" gap="1" alignItems="center">
          <Text size="headline" weight="bold" align="center">
            {title}
          </Text>

          <Text align="center">{description}</Text>
        </Stack>
      </Stack>
    </StepRoot>
  )
}
